import { render, staticRenderFns } from "./UDEApp.vue?vue&type=template&id=7909f0ed&scoped=true"
import script from "./UDEApp.vue?vue&type=script&lang=js"
export * from "./UDEApp.vue?vue&type=script&lang=js"
import style0 from "./UDEApp.vue?vue&type=style&index=0&id=7909f0ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7909f0ed",
  null
  
)

export default component.exports